import { render, staticRenderFns } from "./payRoutestep.vue?vue&type=template&id=74c6b30c&scoped=true"
import script from "./payRoutestep.vue?vue&type=script&lang=js"
export * from "./payRoutestep.vue?vue&type=script&lang=js"
import style0 from "./payRoutestep.vue?vue&type=style&index=0&id=74c6b30c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c6b30c",
  null
  
)

export default component.exports